import styled from 'styled-components';

const RuleBuilderItemButtonsBar = styled.div`
  padding: ${(props): string => props.theme.spaces.md};
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(6.4rem, auto));
  grid-column-gap: ${(props): string => props.theme.spaces.md};
`;

export { RuleBuilderItemButtonsBar };
